import type {
  ApiSpecificSales,
  Period,
  SafeApiComponentProps,
  SalesDistribution,
} from "@pharmupp/p3-front-commons"
import { SpecificChips } from "./SaleChips"
import { SalesGrid } from "./components"

export interface SalesSpecificSectionProps extends ApiSpecificSales {
  distribution: SalesDistribution
  period: Period
}

export const SalesSpecificSection = ({
  specificCategories,
  distribution,
  period,
}: SalesSpecificSectionProps) => {
  return (
    <SalesGrid>
      <SpecificChips
        categories={specificCategories}
        distribution={distribution}
        period={period}
      />
    </SalesGrid>
  )
}

SalesSpecificSection.suspense = {
  skeletonProps: { height: 300 },
} satisfies SafeApiComponentProps["suspense"]
